import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePortalAuth } from '../../context/PortalAuthContext';
import { api } from '../../api/client';
import ThemeToggle from '../../components/ThemeToggle';

const linkBtn = { background: 'none', border: 0, color: 'var(--accent)', cursor: 'pointer', font: 'inherit', textDecoration: 'underline', padding: 0 };

export default function PortalLogin() {
  const { login } = usePortalAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState('login'); // 'login' | 'forgot'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await login(email.trim(), password); nav('/portal', { replace: true }); }
    catch (err) { setError(err?.detail || 'Could not sign in.'); }
    finally { setBusy(false); }
  }

  async function submitForgot(e) {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await api('/portal/forgot-password', { method: 'POST', body: { email: email.trim() } }); setSent(true); }
    catch (err) { setError(err?.detail || 'Could not send the reset link.'); }
    finally { setBusy(false); }
  }

  const goForgot = () => { setMode('forgot'); setError(null); setSent(false); };
  const goLogin = () => { setMode('login'); setError(null); setSent(false); };

  return (
    <div className="portal-auth">
      <div className="portal-auth__top"><ThemeToggle /></div>

      {mode === 'login' ? (
        <form className="portal-card" onSubmit={submit}>
          <h1 className="portal-card__title">Customer Portal</h1>
          <p className="portal-card__sub">Sign in to view your invoices, quotes, and payments.</p>
          {error && <div className="form-error">{error}</div>}
          <div className="field"><label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus required /></div>
          <div className="field"><label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
          <button className="btn btn--primary btn--block" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
          <p style={{ textAlign: 'center', marginTop: 14 }}>
            <button type="button" style={linkBtn} onClick={goForgot}>Forgot your password?</button>
          </p>
        </form>
      ) : (
        <form className="portal-card" onSubmit={submitForgot}>
          <h1 className="portal-card__title">Reset your password</h1>
          {sent ? (
            <>
              <p className="portal-card__sub">If an account exists for that email, we've sent a link to choose a new password. It expires in 2 hours.</p>
              <button type="button" className="btn btn--block" onClick={goLogin}>Back to sign in</button>
            </>
          ) : (
            <>
              <p className="portal-card__sub">Enter your email and we'll send you a link to set a new password.</p>
              {error && <div className="form-error">{error}</div>}
              <div className="field"><label>Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus required /></div>
              <button className="btn btn--primary btn--block" disabled={busy}>{busy ? 'Sending…' : 'Send reset link'}</button>
              <p style={{ textAlign: 'center', marginTop: 14 }}>
                <button type="button" style={linkBtn} onClick={goLogin}>Back to sign in</button>
              </p>
            </>
          )}
        </form>
      )}
    </div>
  );
}
